var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleWoman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.809 19.026C18.9759 18.8295 20.1146 18.4917 21.2 18.02C21.947 17.6843 22.2867 16.8114 21.963 16.059L20.587 12.849C20.3468 12.2888 20.223 11.6856 20.223 11.076V9C20.223 4.44365 16.5293 0.75 11.973 0.75C7.41661 0.75 3.72296 4.44365 3.72296 9V11.076C3.72296 11.6856 3.59913 12.2888 3.35896 12.849L1.98396 16.059C1.66014 16.8111 1.9993 17.6839 2.74596 18.02C3.83129 18.4917 4.97 18.8295 6.13696 19.026",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4491 23.2498C19.7158 19.5863 16.026 17.25 11.9731 17.25C7.92016 17.25 4.23034 19.5863 2.49707 23.2498",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2231 23.2501L16.2571 18.1641",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68896 18.1641L9.72296 23.2501",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.973 5.25C11.973 5.25 10.54 8.85 6.94205 8.995C6.29758 11.1453 7.09163 13.4675 8.91779 14.7731C10.744 16.0786 13.1981 16.0786 15.0243 14.7731C16.8505 13.4675 17.6445 11.1453 17 8.995C13.407 8.847 11.973 5.25 11.973 5.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleWoman);
export default __webpack_public_path__ + "assets/media/peopleWoman.1f913a7c8d1ca7b065d8b15316d2ba1f.svg";
export { ForwardRef as ReactComponent };